import { Link, useLocation } from 'react-router-dom'

import { Button } from 'src/shared/components/ui/buttons/button'
import { SidebarGroup, SidebarMenu, SidebarMenuItem } from 'src/shared/components/ui/miscellaneous/sidebar'
import { useMyUserData } from 'src/shared/features/users/api/accounts/use-my-user'

import type { NavItem } from './nav-config'

export function NavMain({ items }: { items: (NavItem & { component?: React.ReactNode; action?: () => void })[] }) {
  const { data: user } = useMyUserData()
  const location = useLocation()

  const shouldShowItem = (item: NavItem) => {
    if (item.requiredRole) {
      return user?.role === item.requiredRole
    }
    return true
  }

  return (
    <SidebarGroup>
      <SidebarMenu>
        {items.filter(shouldShowItem).map((item) => {
          const isActive = location.pathname.includes(item.url.replace('/', ''))
          const Icon = isActive && item.activeIcon ? item.activeIcon : item.defaultIcon

          return (
            <SidebarMenuItem key={item.title}>
              {item.component || (
                <Link to={item.url}>
                  <Button
                    variant="ghost"
                    className={`w-full justify-start ${
                      item.primary ? 'bg-primary text-primary-foreground hover:bg-primary/90' : ''
                    }`}
                    onClick={item.action}
                  >
                    {Icon && <Icon className="mr-4 size-7" />}
                    {item.title}
                  </Button>
                </Link>
              )}
            </SidebarMenuItem>
          )
        })}
      </SidebarMenu>
    </SidebarGroup>
  )
}
